// src/assets/data/ComplianceTemplates/complianceTemplates.js

// Minimal registry of templates (no fs/path; browser-safe)
const ITEMS = [
  { name: "SR 11-7 — Supervisory Guidance on Model Risk Management", file: "sr-11-7.md" },
  { name: "EU AI Act — Artificial Intelligence Regulation (2024)", file: "eu-ai-act.md" },
  { name: "NIST AI RMF 1.0 — AI Risk Management Framework", file: "nist-ai-rmf-1-0.md" },
  { name: "GDPR — General Data Protection Regulation (EU)", file: "gdpr.md" },
  { name: "CCPA/CPRA — California Consumer Privacy Laws", file: "ccpa-cpra.md" },
  { name: "FDA — AI/ML in Software as a Medical Device (SaMD)", file: "fda-samd-aiml.md" },
  { name: "IEEE 7000 Series — Ethical AI Standards", file: "ieee-7000-series.md" },
];

// Public metadata for dropdowns/lists (just names now)
export const complianceTemplates = ITEMS.map(({ name }) => name);

// Helpers
const base = ""; // CRA serves public/ at site root; no need for PUBLIC_URL
const urlFor = (file) => `${base}/data/ComplianceTemplates/${file}`;

// (Optional) Fetch ONE by display name
export async function fetchComplianceMdByName(name) {
  const item = ITEMS.find((t) => t.name === name);
  if (!item) throw new Error(`Unknown compliance template: ${name}`);
  const res = await fetch(urlFor(item.file), { cache: "no-cache" });
  if (!res.ok) throw new Error(`Failed to load ${item.file} (${res.status})`);
  return res.text();
}

export default complianceTemplates;
